module.exports = __webpack_public_path__ + "static/media/logo2.31aa9527.svg";